// extracted by mini-css-extract-plugin
export default {"errorMessage":"ZendeskSSO_errorMessage__4qjdC"};